<div class="reports-status-section">
  <div class="reports-status-header">
    <h3 class="desktop-dashboard-title">{{ 'reportsStatus' | translate }}</h3>
    <div class="reports-status-copy mobile-dashboard-copy">
      <h3>{{ 'dashboardReports' | translate }}</h3>
      <p>{{ 'dashboardReportsDescription' | translate }}</p>
    </div>
    <div class="reports-status-actions">
      <app-ui-select
        class="vessel-select"
        [label]="'departmentSelector' | translate"
        [control]="vesselControl"
        [options]="vesselOptions()"
        [isMultiple]="false"
        [enableSearch]="true"
        [compactOnMobile]="true"
        triggerPrefix="department"
        panelClass="dashboard-department-select-panel"
      ></app-ui-select>
      <app-dashboard-time-period-select
        class="desktop-dashboard-period-select"
        [periodControl]="periodControl"
        [customRangeControl]="customRangeControl"
      ></app-dashboard-time-period-select>
    </div>
  </div>
  <div
    class="reports-widgets-container"
    *appLoader="(loadingActions | actionInProgress: true | async) === true"
  >
    <!-- Absolute values section -->
    <div class="absolute-values-section">
      <div class="absolute-values-header">
        <span class="absolute-values-title">{{ 'absoluteValuesTitle' | translate }}</span>
        <mat-icon
          class="info-icon"
          [matTooltip]="'absoluteValuesTooltip' | translate"
          matTooltipPosition="above"
        >
          info
        </mat-icon>
      </div>
      <div class="absolute-values-widgets">
        <!-- Expired reports (my + all) -->
        <app-ui-widget-card
          class="expired-widget"
          [blocks]="expiredReportsData"
          statusName="expired"
          statusIcon="error_outline"
          statusColor="red"
          [blockLabels]="['all', 'mine']"
          [statusBlockOrder]="[1, 0]"
          [statusOnMobile]="true"
          [clickable]="true"
          [loading]="expiredReportsLoading"
          [matMenuTriggerFor]="expiredReportsMenu"
          #expiredReportsTrigger="matMenuTrigger"
          (blockClick)="expiredReportsTrigger.openMenu()"
        ></app-ui-widget-card>
        <mat-menu #expiredReportsMenu="matMenu">
          <button mat-menu-item (click)="openExpiredReportsInOpen()">
            <mat-icon>visibility</mat-icon>
            <span>{{ 'openExpiredReportsInOpenState' | translate }}</span>
          </button>
          <button mat-menu-item (click)="openExpiredReportsInCompleted()">
            <mat-icon>check</mat-icon>
            <span>{{ 'openExpiredReportsInCompletedState' | translate }}</span>
          </button>
        </mat-menu>

        <!-- Due soon reports (my + all) -->
        <app-ui-widget-card
          class="due-soon-widget"
          [blocks]="dueSoonReportsData"
          statusName="dueSoon"
          statusIcon="warning_amber"
          statusColor="yellow"
          [blockLabels]="['all', 'mine']"
          [statusBlockOrder]="[1, 0]"
          [statusOnMobile]="true"
          [clickable]="true"
          [loading]="dueSoonReportsLoading"
          [matMenuTriggerFor]="dueSoonReportsMenu"
          #dueSoonReportsTrigger="matMenuTrigger"
          (blockClick)="dueSoonReportsTrigger.openMenu()"
        ></app-ui-widget-card>
        <mat-menu #dueSoonReportsMenu="matMenu">
          <button mat-menu-item (click)="openDueSoonReportsInOpen()">
            <mat-icon>visibility</mat-icon>
            <span>{{ 'openDueSoonReportsInOpenState' | translate }}</span>
          </button>
          <button mat-menu-item (click)="openDueSoonReportsInCompleted()">
            <mat-icon>check</mat-icon>
            <span>{{ 'openDueSoonReportsInCompletedState' | translate }}</span>
          </button>
        </mat-menu>

        <!-- Open reports -->
        <app-ui-widget-card
          class="open-widget"
          name="openReports"
          statusName="open"
          statusIcon="visibility"
          statusColor="blue"
          [statusOnMobile]="true"
          [value]="openReports"
          icon="visibility"
          iconColor="blue"
          [clickable]="true"
          [loading]="openReportsLoading"
          (click)="navigateToOpenReports()"
          [matTooltip]="'openReportsForSelectedDepartments' | translate"
          matTooltipMobileTap="off"
        ></app-ui-widget-card>
      </div>
    </div>

    <!-- Vertical divider -->
    <div class="reports-divider"></div>

    <div class="period-reports-section">
      <div class="period-reports-header">
        <span>{{ 'reportsForSelectedTime' | translate }}</span>
        <app-dashboard-time-period-select
          [periodControl]="periodControl"
          [customRangeControl]="customRangeControl"
        ></app-dashboard-time-period-select>
      </div>
      <div class="reports-widgets-row">
        <!-- Created reports -->
        <app-ui-widget-card
          name="createdReports"
          statusName="created"
          statusIcon="format_list_bulleted"
          statusColor="blue"
          [statusOnMobile]="true"
          [value]="createdReports"
          [description]="!vesselControl.value?.length ? 'fromAllDepartments' : ''"
          icon="format_list_bulleted"
          iconColor="blue"
          [matTooltip]="'createdReportsForTimePeriodTooltip' | translate"
        ></app-ui-widget-card>

        <!-- Completed reports -->
        <app-ui-widget-card
          [routerLink]="reportRoutes.Completed"
          name="completedReports"
          statusName="completed"
          statusIcon="check"
          statusColor="green"
          [statusOnMobile]="true"
          [value]="completedReports"
          descriptionIcon="trending_up"
          descriptionColor="green"
          icon="check"
          iconColor="orange"
          [clickable]="true"
          [matTooltip]="'completedReportsForTimePeriodTooltip' | translate"
          matTooltipMobileTap="off"
        ></app-ui-widget-card>

        <!-- Closed reports -->
        <app-ui-widget-card
          [routerLink]="reportRoutes.Closed"
          name="closedReports"
          statusName="closed"
          statusIcon="key"
          statusColor="green"
          [statusOnMobile]="true"
          [value]="closedReports"
          descriptionIcon="arrow_right_alt"
          descriptionColor="cyan"
          icon="key"
          iconColor="green"
          [clickable]="true"
          [matTooltip]="'closedReportsForTimePeriodTooltip' | translate"
          matTooltipMobileTap="off"
        ></app-ui-widget-card>
      </div>
    </div>
  </div>
</div>
